import { useEffect, useRef, useState } from 'react';

import { useGetDisplayRateQuery, useSetDisplayRateMutation } from '@entities/admin';
import { apiErrorMessage } from '@shared/api/baseApi';
import { haptics } from '@shared/lib/telegram';
import { Button } from '@shared/ui/Button';
import { Card } from '@shared/ui/Card';
import { Spinner } from '@shared/ui/Spinner';
import styles from './shared.module.css';

export function AdminDisplayRate() {
  const { data, isLoading, error: loadError, refetch } = useGetDisplayRateQuery();
  const [save, { isLoading: saving }] = useSetDisplayRateMutation();
  const [value, setValue] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [saved, setSaved] = useState(false);
  const seeded = useRef(false);
  useEffect(() => {
    if (data && !seeded.current) { setValue(data.etbPerUsd); seeded.current = true; }
  }, [data]);
  const submit = async () => {
    setError(null); setSaved(false);
    try {
      const result = await save({ etbPerUsd: value }).unwrap();
      setValue(result.etbPerUsd); setSaved(true); haptics.notify('success');
    } catch (cause) { setError(apiErrorMessage(cause, 'Could not save display rate.')); }
  };
  return (
    <Card className={styles.row}>
      <p className={styles.rowTitle}>Dollar display rate</p>
      <p className={styles.hint}>Customers see and deposit USD. This rate converts deposits to the internal ETB wallet balance.</p>
      {isLoading ? <Spinner /> : loadError ? (
        <Button variant="secondary" onClick={() => void refetch()}>Reload rate</Button>
      ) : (
        <>
          <label className={styles.hint} htmlFor="display-rate">ETB per $1</label>
          <div className={styles.inlineForm}>
            <input id="display-rate" className={styles.input} inputMode="decimal" value={value}
              disabled={saving} maxLength={10} placeholder="195"
              onChange={(event) => { setValue(event.target.value.replace(/[^\d.]/g, '')); setSaved(false); }} />
            <Button loading={saving} disabled={!value} onClick={() => void submit()}>Save rate</Button>
          </div>
          {saved ? <p className={styles.hint} role="status">Saved</p> : null}
        </>
      )}
      {error ? <p className={styles.error} role="alert">{error}</p> : null}
    </Card>
  );
}
